import React from 'react'
//CSS
import * as css from '../FondosAsignados.css'
//Componentes
import { RowFondosAsignados } from './RowFondosAsignados.jsx'

export class TablaFondosAsignados extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        let cantidadFondosAsignados = this.props.fondos.length
        return (
            <div className="panel panel-default">
                <TableFondoA>
                    {_.range(0, cantidadFondosAsignados).map(index=>{
                        let fondo = this.props.fondos[index]
                        return <RowFondosAsignados
                            key={index}
                            index={index}
                            fondo={fondo}
                        />
                    })}
                </TableFondoA>
            </div>
        )
    }
}
let TableFondoA = ({children}) =>
    <table className={"table table-condensed "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colNSemana}/>
            <col className={css.colEstado}/>
            <col className={css.colEstado}/>
            <col className={css.colRendir}/>
            <col className={css.colRendir}/>
            <col className={css.colTotalGasto}/>
            <col className={css.colDiferencia}/>
            <col className={css.colAcciones}/>
            <col className={css.colAcciones}/>
        </colgroup>
        <thead>
            <tr>
                <th className={css.thIndex}>#</th>
                <th className={css.thNSemana}>Semana</th>
                <th className={css.thEstado}>Año</th>
                <th className={css.thEstado}>Estado</th>
                <th className={css.thRendir}>Total Deposito</th>
                <th className={css.thRendir}>Total a Rendir</th>
                <th className={css.thTotalGasto}>Total Gastos</th>
                <th className={css.thDiferencia}>Diferencia</th>
                <th className={css.thAcciones}>Voucher</th>
                <th className={css.thAcciones}>Detalle</th>
            </tr>
        </thead>
        <tbody>
            {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/fondos/TablaFondosAsignados.jsx